import Paragraph from "~/componentsDS/Typography/Paragraph";
import { HormoneSupportOestraDesktopContent } from "../../data/hormone-support-content";

const HormoneSupportOestraCard = ({ content }: { content: HormoneSupportOestraDesktopContent }) => {
    return (
        <div
            className="
                relative h-[550px] w-full overflow-hidden rounded-[16px] p-8 text-center
                shadow-[1px_1px_9.2px_0px_rgba(0,0,0,0.25)]
                bg-no-repeat
                bg-[length:1300px_auto]
                bg-[position:50%_28%]
            "
            style={{
                backgroundImage: `url('${content.backgroundImage}')`,
            }}
        >
            <div className="relative flex h-full flex-col text-pureWhite">
                <Paragraph
                    as="h3"
                    weight="300"
                    className="mb-[10px] text-[26px] leading-[1.1] tracking-[-0.265px] text-primary500"
                >
                    {content.description}
                </Paragraph>

                <div className="mt-auto">
                    {content.badge}
                    <ul>
                        {content.bullets.map((item) => (
                            <li key={item}>
                                <Paragraph>{item}</Paragraph>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default HormoneSupportOestraCard;
